import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import { UserAdsTable } from "../../UI/UserAds/UserAdsTable";

const UserAds = () => {
  return (
    <div>
      <PanelHead title="UserAds" />
      <PanelBody content={<UserAdsTable />} />
    </div>
  );
};

export default UserAds;
